"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-five/sections/reviewsSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode, useRef } from "react";

type ReviewsSectionAvatarAvatarRoundedsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/doctors/doctor-thumb-22.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-23.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-24.jpg" */
    src: string;
    /** Detected variants: "avatar avatar-rounded" */
    className?: string;
    /** Detected variants: "img" */
    alt?: string;
    /** Detected variants: "border border-white" */
    imageWithBasePath0ClassName?: string;
};

type ReviewsSectionSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Absolutely amazing with kids. She keeps my children calm and comfortable during every visit. The office is bright, fun, and welcoming, making dental care." | "Outstanding care combined with a warm, welcoming environment. The team is highly knowledgeable patients, making every visit a positive experience." | "A caring team and a comforting atmosphere. They go above and beyond to make sure every patient feels valued and well cared for truly cares and makes every visit pleasant." */
    p0Text: ReactNode;
    /** Detected variants: "Gregg Lewis" | "Michael Smith" | "Stephanie Johnson" */
    h30Text: ReactNode;
    /** Detected variants: "San Diego, CA" | "San Francisco, CA" | "Los Angeles, CA" */
    p0P0Text: ReactNode;
    /** Detected variants: "slide-item" */
    className?: string;
    /** Detected variants: "testimonial-item-five" */
    div0ClassName?: string;
    /** Detected variants: "testimonial-content" */
    div0ClassName2?: string;
    /** Detected variants: "quatation" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/quatation-icon.svg" */
    src?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "testimonial-author" */
    div1ClassName?: string;
    /** Detected variants: "author" */
    div0ClassName3?: string;
    /** Detected variants: "custom-title author-name" */
    h30ClassName?: string;
    /** Detected variants: "author-location" */
    p0ClassName2?: string;
    reviewItems?: ReviewsSectionFaSolidFaStarsItem[];
};

type ReviewsSectionFaSolidFaStarsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-solid fa-star" */
    className?: string;
};

type ReviewsSectionSlides2Item = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/company/company-five-1.svg" | "/Templates/Doccure/img/company/company-five-2.svg" | "/Templates/Doccure/img/company/company-five-3.svg" | "/Templates/Doccure/img/company/company-five-4.svg" | "/Templates/Doccure/img/company/company-five-5.svg" | "/Templates/Doccure/img/company/company-five-6.svg" */
    src: string;
    /** Detected variants: "slide-item" */
    className?: string;
    /** Detected variants: "img" */
    alt?: string;
};
const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 2,
    autoplay: false,
    arrows: false, // controlled manually
    responsive: [
        {
            breakpoint: 576,
            settings: { slidesToShow: 1 },
        },

    ],
};

const settings_slider = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToScroll: 1,
    slidesToShow: 6,
    autoplay: true,
    arrows: false,
    responsive: [

        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 576, // ✅ FIXED
            settings: {
                slidesToShow: 2,
            },
        },
    ],
};

export type HomeFiveReviewsSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ReviewsSectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ReviewsSectionSlidesItem) => Partial<ComponentProps<"h3">>);
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ReviewsSectionSlides2Item) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "4.9k" */
    sectionDiv0Div0Div0Div0Div0Div1DivText?: ReactNode;
    /** Default: "Customer experiences that speak for themselves" */
    sectionDiv0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "review-left-img" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/reviews/review-left-img.jpg" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "CLIENT REVIEWS" */
    sectionDiv0Div0Div1Div0Div0Div0DivText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/title-icon1.svg" */
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "What Our Patients Say About Us" */
    sectionDiv0Div0Div1Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    sectionDiv0Div0Div1Div0Div1Button0ButtonVisible?: boolean;
    sectionDiv0Div0Div1Div0Div1Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div1Button0ButtonProps?: Partial<ComponentProps<"button">>;
    sectionDiv0Div0Div1Div0Div1Button1ButtonVisible?: boolean;
    sectionDiv0Div0Div1Div0Div1Button1ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div1Button1ButtonProps?: Partial<ComponentProps<"button">>;
    sectionDiv0Div0Div1Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    sectionDiv1Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    /** Default: "article-bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/article-bg-1.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    spanImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ReviewsSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    reviewsSectionAvatarAvatarRoundeds: ReviewsSectionAvatarAvatarRoundedsItem[];
    reviewsSectionSlides: ReviewsSectionSlidesItem[];
    reviewsSectionSlides2: ReviewsSectionSlides2Item[];
    reviewsSectionAvatarAvatarRoundedsItemWrapper?: (item: ReviewsSectionAvatarAvatarRoundedsItem, content: ReactNode) => ReactNode;
    reviewsSectionAvatarAvatarRoundedsRenderer?: (defaultNode: ReactNode) => ReactNode;
    reviewsSectionAvatarAvatarRoundedsImageVisible?: boolean;
    reviewsSectionAvatarAvatarRoundedsImageRenderer?: (item: ReviewsSectionAvatarAvatarRoundedsItem, defaultNode: ReactNode) => ReactNode;
    reviewsSectionAvatarAvatarRoundedsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ReviewsSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    reviewsSectionSlidesItemWrapper?: (item: ReviewsSectionSlidesItem, content: ReactNode) => ReactNode;
    reviewsSectionSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    reviewsSectionSlidesImageVisible?: boolean;
    reviewsSectionSlidesImageRenderer?: (item: ReviewsSectionSlidesItem, defaultNode: ReactNode) => ReactNode;
    reviewsSectionSlidesH3Visible?: boolean;
    reviewsSectionSlidesH3Renderer?: (item: ReviewsSectionSlidesItem, defaultNode: ReactNode) => ReactNode;
    reviewsSectionSlidesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ReviewsSectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    reviewsSectionSlidesH3Props?: Partial<ComponentProps<"h3">> | ((item: ReviewsSectionSlidesItem) => Partial<ComponentProps<"h3">>);
    reviewsSectionFaSolidFaStarsItemWrapper?: (item: ReviewsSectionFaSolidFaStarsItem, content: ReactNode) => ReactNode;
    reviewsSectionFaSolidFaStarsRenderer?: (defaultNode: ReactNode) => ReactNode;
    reviewsSectionSlides2ItemWrapper?: (item: ReviewsSectionSlides2Item, content: ReactNode) => ReactNode;
    reviewsSectionSlides2Renderer?: (defaultNode: ReactNode) => ReactNode;
    reviewsSectionSlides2ImageVisible?: boolean;
    reviewsSectionSlides2ImageRenderer?: (item: ReviewsSectionSlides2Item, defaultNode: ReactNode) => ReactNode;
    reviewsSectionSlides2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ReviewsSectionSlides2Item) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeFiveReviewsSectionGenerated: FC<HomeFiveReviewsSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0Div1DivText = "4.9k",
    sectionDiv0Div0Div0Div0Div0P0PText = "Customer experiences that speak for themselves",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt = "review-left-img",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/reviews/review-left-img.jpg",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div0Div0DivText = "CLIENT REVIEWS",
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/title-icon1.svg",
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div0H20H2Text = "What Our Patients Say About Us",
    sectionDiv0Div0Div1Div0Div0H20H2Visible,
    sectionDiv0Div0Div1Div0Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0Div0H20H2Props,
    sectionImageWithBasePath0ImageAlt = "article-bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/article-bg-1.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div1Button0ButtonVisible,
    sectionDiv0Div0Div1Div0Div1Button0ButtonRenderer,
    sectionDiv0Div0Div1Div0Div1Button0ButtonProps,
    sectionDiv0Div0Div1Div0Div1Button1ButtonVisible,
    sectionDiv0Div0Div1Div0Div1Button1ButtonRenderer,
    sectionDiv0Div0Div1Div0Div1Button1ButtonProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1Div0H30H3Props,
    divImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Slider0SliderProps,
    sectionDiv1Slider0SliderProps,
    spanImageWithBasePath0ImageProps,
    sectionDiv0Div0ClassName,
    reviewsSectionAvatarAvatarRoundeds,
    reviewsSectionSlides,
    reviewsSectionSlides2,
    reviewsSectionAvatarAvatarRoundedsItemWrapper,
    reviewsSectionAvatarAvatarRoundedsRenderer,
    reviewsSectionAvatarAvatarRoundedsImageVisible,
    reviewsSectionAvatarAvatarRoundedsImageRenderer,
    reviewsSectionAvatarAvatarRoundedsImageProps,
    reviewsSectionSlidesItemWrapper,
    reviewsSectionSlidesRenderer,
    reviewsSectionSlidesImageVisible,
    reviewsSectionSlidesImageRenderer,
    reviewsSectionSlidesH3Visible,
    reviewsSectionSlidesH3Renderer,
    reviewsSectionSlidesImageProps,
    reviewsSectionSlidesH3Props,
    reviewsSectionFaSolidFaStarsItemWrapper,
    reviewsSectionFaSolidFaStarsRenderer,
    reviewsSectionSlides2ItemWrapper,
    reviewsSectionSlides2Renderer,
    reviewsSectionSlides2ImageVisible,
    reviewsSectionSlides2ImageRenderer,
    reviewsSectionSlides2ImageProps,
}) => {
    const sliderRef = useRef<Slider | null>(null);
    return (
        <section className="review-section-five section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row"}>
                    <div className="col-lg-4">
                        <div className="review-img-five">
                            {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            <div className="review-item">
                                <div className="avatar-list-stacked avatar-group-lg">
                                    {renderCollectionNode(
                                        reviewsSectionAvatarAvatarRoundeds,
                                        (item: ReviewsSectionAvatarAvatarRoundedsItem) => (
                                            <span className={item.className ?? "avatar avatar-rounded"} key={item.key}>
                                                {renderItemNode(reviewsSectionAvatarAvatarRoundedsImageVisible, reviewsSectionAvatarAvatarRoundedsImageRenderer, item, (
                                                    <SmartImage className={item.imageWithBasePath0ClassName ?? "border border-white"} src={item.src} alt={item.alt ?? "img"} {...(typeof reviewsSectionAvatarAvatarRoundedsImageProps === "function" ? reviewsSectionAvatarAvatarRoundedsImageProps(item) : (reviewsSectionAvatarAvatarRoundedsImageProps ?? {}))} {...(typeof spanImageWithBasePath0ImageProps === "function" ? spanImageWithBasePath0ImageProps(item) : (spanImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </span>
                                        ),
                                        reviewsSectionAvatarAvatarRoundedsItemWrapper,
                                        reviewsSectionAvatarAvatarRoundedsRenderer
                                    )}
                                </div>
                                <div className="count">{sectionDiv0Div0Div0Div0Div0Div1DivText}</div>
                                <p className="description">{sectionDiv0Div0Div0Div0Div0P0PText}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="review-right">
                            <div className="section-header section-header-five">
                                <div className="section-sub-title">
                                    {" "}
                                    {renderNode(sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                    {sectionDiv0Div0Div1Div0Div0Div0DivText}
                                </div>
                                {renderNode(sectionDiv0Div0Div1Div0Div0H20H2Visible, sectionDiv0Div0Div1Div0Div0H20H2Renderer, (
                                    <h2 className="section-title" {...(sectionDiv0Div0Div1Div0Div0H20H2Props ?? {})}>{sectionDiv0Div0Div1Div0Div0H20H2Text}</h2>
                                ))}
                            </div>
                            <div className="slide-btn">
                                {renderNode(sectionDiv0Div0Div1Div0Div1Button0ButtonVisible, sectionDiv0Div0Div1Div0Div1Button0ButtonRenderer, (
                                    <button type="button" className="slick-arrow testimonial-prev" {...(sectionDiv0Div0Div1Div0Div1Button0ButtonProps ?? {})}>
                                        <i className="isax isax-arrow-left" />
                                    </button>
                                ))}
                                {renderNode(sectionDiv0Div0Div1Div0Div1Button1ButtonVisible, sectionDiv0Div0Div1Div0Div1Button1ButtonRenderer, (
                                    <button type="button" className="slick-arrow testimonial-next" {...(sectionDiv0Div0Div1Div0Div1Button1ButtonProps ?? {})}>
                                        <i className="isax isax-arrow-right-1" />
                                    </button>
                                ))}
                            </div>
                        </div>
                        <Slider ref={sliderRef} {...settings} className="testimonial-slider-five" {...(sectionDiv0Div0Div1Slider0SliderProps ?? {})}>
                            {renderCollectionNode(
                                reviewsSectionSlides,
                                (item: ReviewsSectionSlidesItem) => (
                                    <div className={item.className ?? "slide-item"} key={item.key}>
                                        <div className={item.div0ClassName ?? "testimonial-item-five"}>
                                            <div className={item.div0ClassName2 ?? "testimonial-content"}>
                                                {renderItemNode(reviewsSectionSlidesImageVisible, reviewsSectionSlidesImageRenderer, item, (
                                                    <SmartImage src={item.src ?? "/Templates/Doccure/img/icons/quatation-icon.svg"} alt={item.alt ?? "quatation"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof reviewsSectionSlidesImageProps === "function" ? reviewsSectionSlidesImageProps(item) : (reviewsSectionSlidesImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                                <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                            </div>
                                            <div className={item.div1ClassName ?? "testimonial-author"}>
                                                <div className={item.div0ClassName3 ?? "author"}>
                                                    {renderItemNode(reviewsSectionSlidesH3Visible, reviewsSectionSlidesH3Renderer, item, (
                                                        <h3 className={item.h30ClassName ?? "custom-title author-name"} {...(typeof reviewsSectionSlidesH3Props === "function" ? reviewsSectionSlidesH3Props(item) : (reviewsSectionSlidesH3Props ?? {}))} {...(typeof divDiv0Div1Div0H30H3Props === "function" ? divDiv0Div1Div0H30H3Props(item) : (divDiv0Div1Div0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                                    ))}
                                                    <p className={item.p0ClassName2 ?? "author-location"}>{item.p0P0Text}</p>
                                                </div>
                                                <div className="review">
                                                    {renderCollectionNode(
                                                        item.reviewItems ?? [],
                                                        (item: ReviewsSectionFaSolidFaStarsItem) => (
                                                            <i className={item.className ?? "fa-solid fa-star"} key={item.key} />
                                                        ),
                                                        reviewsSectionFaSolidFaStarsItemWrapper,
                                                        reviewsSectionFaSolidFaStarsRenderer
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ),
                                reviewsSectionSlidesItemWrapper,
                                reviewsSectionSlidesRenderer
                            )}
                        </Slider>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="element-1" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            <div className="container">
                <Slider {...settings_slider} className="company-slider company-slider-five" {...(sectionDiv1Slider0SliderProps ?? {})}>
                    {renderCollectionNode(
                        reviewsSectionSlides2,
                        (item: ReviewsSectionSlides2Item) => (
                            <div className={item.className ?? "slide-item"} key={item.key}>
                                {renderItemNode(reviewsSectionSlides2ImageVisible, reviewsSectionSlides2ImageRenderer, item, (
                                    <SmartImage src={item.src} alt={item.alt ?? "img"} {...(typeof reviewsSectionSlides2ImageProps === "function" ? reviewsSectionSlides2ImageProps(item) : (reviewsSectionSlides2ImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                ))}
                            </div>
                        ),
                        reviewsSectionSlides2ItemWrapper,
                        reviewsSectionSlides2Renderer
                    )}
                </Slider>
            </div>
        </section>
    );
};

export default HomeFiveReviewsSectionGenerated;
